/**
 * Medium Words Pack - 7-8 letter words  
 * Combines words-7.ts and words-8.ts for moderate difficulty
 */

import { WordPack } from '../../types/GameTypes';
import words7 from '../words-7';
import words8 from '../words-8';

const mediumWordsPack: WordPack = {
  id: 'medium-words',
  name: 'Medium Words (7-8 Letters)',
  description: 'Balanced challenge with medium-length words',
  difficulty: 'medium',
  words: [...words7, ...words8]
};

export default mediumWordsPack;